import { Button } from 'react-bootstrap'
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { FaPlus } from 'react-icons/fa'

class Createbutton extends React.Component{
    render() {
        const { t } = this.props  

        return <div 
            style={this.props.style ? this.props.style : {
                padding:"20px", 
                float: "right"
            }}
            className={this.props.class}
        >
            <Button
                variant="success"
                onClick={() => this.props.toggleCreate()}
                className='create-button'
            >
                <FaPlus size={20} /> 
                <span>
                    {t('Create')}
                </span>
            </Button>
        </div> 
    }
}

export default (withNamespaces()(Createbutton));